export const group = {
  name: "Grupo |||| Grupos",
  fields: {
    name: "Nome",
    groupUsersIds: "Usuários",
  },
};
